





















import { Component, Vue } from 'vue-property-decorator';
import { Actions, Endpoints } from '@/ts/store/Constants';
import FlexibleTable from '@/components/Tables/FlexibleTable.vue';
import { dateTimeFormat, dateFormat } from '@/ts/DefaultTableConfigs';
import WaitingListsData from '@/ts/WaitingListsData';
import { TableViewConfig } from '@/ts/interfaces/TableConfigTypes';

@Component({
    components: {
        FlexibleTable,
    },
})
export default class WaitingList extends Vue {
    public tableEntity: string = 'WaitingList';
    public columns: any = [
        { name: 'id', label: this.$t('general.id-text', 'ID'), align: 'left', field: 'id', sortable: true, required: true },
        { name: 'applicationId', label: this.$t('waiting-list.application-id', 'Application ID'), align: 'left', field: 'typeFormApplicationId', sortable: true },
        { name: 'name', label: this.$t('general.name', 'Name'), align: 'left', field: 'name', sortable: true },
        { name: 'interestedFrom', label: this.$t('general.application-interest-from', 'Interest from'), align: 'left', field: 'interestedFrom', sortable: true, filterType: 'date', dateFormat },
        { name: 'createdAt', label: this.$t('general.application-date', 'Application date'), align: 'left', field: 'createdAt', sortable: true, filterType: 'date', dateFormat: dateTimeFormat,
            sort: (a: any, b: any) => {
                const aTimestamp = a !== '' ? this.$moment(a, dateTimeFormat).valueOf() : 0;
                const bTimestamp = b !== '' ? this.$moment(b, dateTimeFormat).valueOf() : 0;

                return aTimestamp - bTimestamp;
            },
        },
        { name: 'address', label: this.$t('general.address', 'Address'), align: 'left', field: 'address', sortable: true },
        { name: 'projects', label: this.$t('general.projects', 'Projects'), align: 'left', field: 'projects', sortable: true, filterType: 'array' },
        { name: 'types', label: this.$t('general.types', 'Types'), align: 'left', field: 'types', sortable: true, filterType: 'array' },
        { name: 'email', label: this.$t('general.email', 'Email'), align: 'left', field: 'email', sortable: true },
        { name: 'phone', label: this.$t('general.phone', 'Phone'), align: 'left', field: 'phone', sortable: true },
        { name: 'gender', label: this.$t('general.gender', 'Gender') , align: 'left', field: 'gender', sortable: true },
        { name: 'age', label: this.$t('general.age', 'Age') , align: 'left', field: 'age', sortable: true },
        { name: 'educationTags', label: this.$t('general.education', 'Education') , align: 'left', field: 'educationTags', sortable: true, filterType: 'array' },
        { name: 'interestsTags', label: this.$t('general.interests', 'Interests') , align: 'left', field: 'interestsTags', sortable: true, filterType: 'array' },
        { name: 'status', label: this.$t('general.status', 'Status'), align: 'left', field: 'status', sortable: true },
        { name: 'aboutMe', label: this.$t('general.about-me', 'About me') , align: 'left', field: 'aboutMe', sortable: true },
        { name: 'applicationMotivation', label: this.$t('general.application-motivation', 'Application motivation') , align: 'left', field: 'applicationMotivation', sortable: true },
        { name: 'minSize', label: this.$t('general.min_apartment_size', 'Min.size (m²)') , align: 'left', field: 'minSize', sortable: true, filterType: 'max-value-optional' },
        { name: 'maxSize', label: this.$t('general.max_apartment_size', 'Max. size (m²)') , align: 'left', field: 'maxSize', sortable: true, filterType: 'min-value-optional' },
        { name: 'minRent', label: this.$t('general.min_rent', 'Min. rent') , align: 'left', field: 'minRent', sortable: true, filterType: 'max-value-optional' },
        { name: 'maxRent', label: this.$t('general.max_rent', 'Max. rent') , align: 'left', field: 'maxRent', sortable: true, filterType: 'min-value-optional' },
        { name: 'numberOfRooms', label: this.$t('general.number_of_rooms', 'Number of rooms') , align: 'left', field: 'numberOfRooms', sortable: true},
        { name: 'optionAnswers', label: this.$t('general.zones', 'Zones') , align: 'left', field: 'optionAnswers', sortable: true, filterType: 'array' },
    ];

    constructor() {
        super();
    }

     get defaultTableConfig(): TableViewConfig {
        return {
            visibleColumns: [
                'id',
                'applicationId',
                'createdAt',
                'interestedFrom',
                'name',
                'email',
                'phone',
                'projects',
                'types',
            ],
        };
    }

    get activeType(): string {
        return this.$store.getters['WaitingLists/getRequestTypeOption'];
    }

    get waitingListData(): WaitingListsData[] {
        return this.$store.getters['WaitingLists/getAllWaitingLists'];
    }

    get requireLoading() {
        return this.$store.getters['Loading/getRequestTokenByURL'](Endpoints.Admin.WaitingList.WAITING_LISTS);
    }

    public fetchCurrentApplication(applicationId: number)  {
        this.$store.dispatch(Actions.FETCH_CURRENT_APPLICATION_MASTER_DATA, applicationId);
        this.$store.dispatch(Actions.FETCH_CURRENT_PREVIEWED_APPLICATION, applicationId);
    }
}
